import { SYDNEY_TIME_ZONE } from "@stb/jurisdiction-au/month"

/**
 * Pure status derivation (invoicing plan, "Payments and status"). The rules moved to
 * `@stb/jurisdiction-au/invoice-support` (T511) so the native apps share them through the
 * golden vectors; this file keeps the web-only Sydney clock.
 */
export {
  deriveInvoiceStatus,
  isSendActive,
  type InvoiceStatusInput as StatusInput,
} from "@stb/jurisdiction-au/invoice-support"

const dayFormat = new Intl.DateTimeFormat("en-CA", {
  timeZone: SYDNEY_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
})

/** `YYYY-MM-DD` of `now` in Australia/Sydney: the calendar day invoices are due by. */
export function sydneyToday(now: Date): string {
  return dayFormat.format(now)
}
